import { render, staticRenderFns } from "./Element.vue?vue&type=template&id=1f046a1f&scoped=true"
import script from "./Element.vue?vue&type=script&lang=js"
export * from "./Element.vue?vue&type=script&lang=js"
import style0 from "./Element.vue?vue&type=style&index=0&id=1f046a1f&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1f046a1f",
  null
  
)

export default component.exports